export enum NewsSites {
  Bevnet = 1,
  Brewbound = 2,
  Nosh = 3,
  BevnetApp = 4,
}
